// src/pages/NotFoundPage.tsx — Site officiel Vanessa
import { Link } from 'react-router-dom';
import { buttonClasses } from '@/components/ui/button';

export default function NotFoundPage() {
    return (
        <div className="flex flex-col items-center justify-center gap-4 px-4 py-24 text-center">
            <img src="/vanessa-avatar.png" alt="" className="h-24 w-24 rounded-full object-cover ring-4 ring-brand" />
            <h1 className="font-display text-3xl font-bold text-ink">Cette page n’existe pas.</h1>
            <p className="max-w-md text-lg text-gray-700">Même Vanessa ne l’a pas trouvée. Revenons à l’accueil.</p>
            <Link to="/" className={buttonClasses('primary', 'lg')}>Retour à l’accueil</Link>
        </div>
    );
}
